module.exports = __webpack_public_path__ + "static/scale-model-of-the-pole-in-long-beach-california-1e6e98f9aad1b826211cf16ffc1f4a15.png";